var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartPocketV2LogoWeb200X40Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 30",
    style: {
      enableBackground: "new 0 0 90 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:none;stroke:#9D9D9C;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#9D9D9C;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.st4{fill:#F0E85F;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st5{fill:#54AEC8;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st7{fill:#010202;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st8{fill:#EFE85F;}\r\n\t.st9{fill:none;stroke:#1E1E1C;stroke-width:0.25;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reticula",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -70.6,
    y: -333.96,
    className: "st2",
    width: 236.49,
    height: 236.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -97.48,
    x2: 165.89,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -109.3,
    x2: 165.89,
    y2: -109.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -121.13,
    x2: 165.89,
    y2: -121.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -132.95,
    x2: 165.89,
    y2: -132.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -144.78,
    x2: 165.89,
    y2: -144.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -156.6,
    x2: 165.89,
    y2: -156.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -168.42,
    x2: 165.89,
    y2: -168.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -180.25,
    x2: 165.89,
    y2: -180.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -192.07,
    x2: 165.89,
    y2: -192.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -203.9,
    x2: 165.89,
    y2: -203.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -215.72,
    x2: 165.89,
    y2: -215.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -227.55,
    x2: 165.89,
    y2: -227.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -239.37,
    x2: 165.89,
    y2: -239.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -251.19,
    x2: 165.89,
    y2: -251.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -263.02,
    x2: 165.89,
    y2: -263.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -274.84,
    x2: 165.89,
    y2: -274.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -286.67,
    x2: 165.89,
    y2: -286.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -298.49,
    x2: 165.89,
    y2: -298.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -310.32,
    x2: 165.89,
    y2: -310.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -70.6,
    y1: -322.14,
    x2: 165.89,
    y2: -322.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 165.89,
    y1: -333.96,
    x2: 165.89,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 154.06,
    y1: -333.96,
    x2: 154.06,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 142.24,
    y1: -333.96,
    x2: 142.24,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 130.41,
    y1: -333.96,
    x2: 130.41,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 118.59,
    y1: -333.96,
    x2: 118.59,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 106.76,
    y1: -333.96,
    x2: 106.76,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 94.94,
    y1: -333.96,
    x2: 94.94,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 83.12,
    y1: -333.96,
    x2: 83.12,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 71.29,
    y1: -333.96,
    x2: 71.29,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 59.47,
    y1: -333.96,
    x2: 59.47,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 47.64,
    y1: -333.96,
    x2: 47.64,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 35.82,
    y1: -333.96,
    x2: 35.82,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 23.99,
    y1: -333.96,
    x2: 23.99,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 12.17,
    y1: -333.96,
    x2: 12.17,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0.34,
    y1: -333.96,
    x2: 0.34,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -11.48,
    y1: -333.96,
    x2: -11.48,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -23.31,
    y1: -333.96,
    x2: -23.31,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -35.13,
    y1: -333.96,
    x2: -35.13,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -46.95,
    y1: -333.96,
    x2: -46.95,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -58.78,
    y1: -333.96,
    x2: -58.78,
    y2: -97.48
  }), /*#__PURE__*/React.createElement("rect", {
    x: -70.6,
    y: -333.96,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -23.3,
    y: -333.96,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.99,
    y: -333.96,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.29,
    y: -333.96,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.59,
    y: -333.96,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -70.6,
    y: -286.67,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -23.3,
    y: -286.67,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.99,
    y: -286.67,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.29,
    y: -286.67,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.59,
    y: -286.67,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -70.6,
    y: -239.37,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -23.3,
    y: -239.37,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.99,
    y: -239.37,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.29,
    y: -239.37,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.59,
    y: -239.37,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -70.6,
    y: -192.07,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -23.3,
    y: -192.07,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.99,
    y: -192.07,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.29,
    y: -192.07,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.59,
    y: -192.07,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -70.6,
    y: -144.78,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -23.3,
    y: -144.78,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.99,
    y: -144.78,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.29,
    y: -144.78,
    className: "st3",
    width: 47.3,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.59,
    y: -144.78,
    className: "st3",
    width: 47.3,
    height: 47.3
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.46,13.54c-0.27,0-0.55-0.02-0.84-0.06c-0.29-0.04-0.55-0.11-0.79-0.22c-0.24-0.1-0.44-0.24-0.59-0.42 c-0.15-0.18-0.22-0.4-0.22-0.67c0-0.32,0.08-0.55,0.25-0.7c0.17-0.15,0.44-0.22,0.82-0.22c0.23,0,0.49,0.02,0.76,0.06 c0.28,0.04,0.51,0.06,0.69,0.06c0.21,0,0.37-0.03,0.47-0.1c0.1-0.06,0.16-0.15,0.16-0.25c0-0.08-0.03-0.15-0.09-0.21 c-0.06-0.06-0.17-0.11-0.31-0.16c-0.15-0.05-0.35-0.1-0.61-0.16c-0.47-0.09-0.84-0.21-1.13-0.36c-0.29-0.15-0.5-0.34-0.63-0.56 c-0.13-0.23-0.19-0.5-0.19-0.81c0-0.36,0.07-0.68,0.21-0.94c0.14-0.26,0.33-0.49,0.57-0.67s0.5-0.33,0.79-0.45 c0.29-0.11,0.59-0.2,0.89-0.25s0.59-0.08,0.87-0.08c0.61,0,1.1,0.1,1.47,0.31c0.37,0.21,0.55,0.5,0.55,0.89 c0,0.3-0.1,0.55-0.3,0.74s-0.51,0.29-0.92,0.29c-0.14,0-0.31-0.01-0.5-0.02c-0.19-0.02-0.38-0.04-0.56-0.06 C47.1,8.5,46.94,8.49,46.8,8.49c-0.23,0-0.4,0.03-0.51,0.09s-0.17,0.15-0.17,0.27c0,0.06,0.03,0.13,0.08,0.19 c0.05,0.06,0.15,0.12,0.29,0.18c0.14,0.06,0.35,0.13,0.62,0.2c0.56,0.14,1,0.3,1.32,0.49c0.32,0.19,0.55,0.41,0.69,0.65 c0.14,0.25,0.21,0.53,0.21,0.84c0,0.43-0.12,0.8-0.36,1.12c-0.24,0.32-0.58,0.57-1.01,0.75S47.03,13.54,46.46,13.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.01,9.08c0.07-0.27,0.19-0.5,0.36-0.72c0.17-0.21,0.38-0.38,0.63-0.51c0.25-0.13,0.52-0.19,0.81-0.19 c0.36,0,0.68,0.08,0.95,0.24c0.28,0.16,0.49,0.43,0.65,0.79c0.16,0.37,0.24,0.86,0.24,1.47c0,0.3-0.01,0.61-0.04,0.92 s-0.06,0.6-0.1,0.86c-0.04,0.27-0.08,0.49-0.13,0.67c-0.08,0.3-0.22,0.53-0.41,0.68c-0.2,0.15-0.44,0.22-0.72,0.22 c-0.27,0-0.48-0.08-0.63-0.24s-0.23-0.38-0.23-0.67c0-0.12,0.02-0.27,0.05-0.47s0.07-0.4,0.11-0.63s0.08-0.45,0.11-0.67 s0.05-0.41,0.05-0.57c0-0.24-0.05-0.42-0.14-0.56c-0.09-0.13-0.23-0.2-0.4-0.2c-0.21,0-0.37,0.12-0.5,0.37 c-0.13,0.25-0.21,0.6-0.25,1.07c-0.02,0.37-0.04,0.7-0.07,0.98c-0.03,0.29-0.08,0.53-0.15,0.72c-0.07,0.22-0.18,0.38-0.33,0.49 s-0.34,0.16-0.59,0.16c-0.27,0-0.48-0.08-0.64-0.23c-0.16-0.16-0.25-0.4-0.26-0.73c-0.01-0.21-0.01-0.45,0-0.73 c0-0.28,0.01-0.55,0.01-0.82c0-0.27,0-0.5-0.01-0.68c-0.01-0.28-0.07-0.49-0.16-0.62s-0.23-0.2-0.41-0.2 c-0.19,0-0.35,0.1-0.46,0.29c-0.11,0.19-0.19,0.46-0.22,0.8c-0.01,0.16-0.02,0.36-0.01,0.59c0,0.23,0.01,0.46,0.01,0.69 c0,0.23,0,0.42,0,0.59c-0.01,0.45-0.11,0.76-0.27,0.95c-0.17,0.19-0.4,0.29-0.7,0.29c-0.34,0-0.59-0.09-0.75-0.28 s-0.26-0.49-0.3-0.91c-0.03-0.26-0.05-0.53-0.06-0.79C50.01,11.25,50,10.99,50,10.72c0-0.26,0.01-0.55,0.03-0.85 c0.02-0.3,0.04-0.59,0.07-0.87c0.05-0.4,0.15-0.74,0.3-1.01c0.15-0.27,0.39-0.41,0.72-0.41c0.3,0,0.51,0.09,0.64,0.28 c0.13,0.18,0.19,0.47,0.19,0.85c0,0.13-0.01,0.25-0.03,0.36L51.9,8.87c0.13-0.42,0.35-0.75,0.66-0.98 c0.31-0.24,0.65-0.35,1.02-0.35c0.49,0,0.86,0.15,1.13,0.44c0.27,0.29,0.42,0.7,0.44,1.22L55.01,9.08z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.95,13.61c-0.34,0-0.57-0.09-0.68-0.26c-0.11-0.17-0.17-0.44-0.17-0.82l0.15,0.05c-0.36,0.7-1.05,1.06-2.08,1.06 c-0.47,0-0.85-0.08-1.16-0.24c-0.31-0.16-0.53-0.37-0.68-0.63s-0.22-0.55-0.22-0.87c0-0.54,0.2-0.97,0.61-1.29 c0.41-0.32,0.94-0.47,1.62-0.47c0.42,0,0.79,0.06,1.1,0.18s0.58,0.29,0.79,0.51l-0.28-0.02c-0.01-0.54-0.12-0.93-0.33-1.16 c-0.21-0.23-0.51-0.34-0.9-0.34c-0.18,0-0.37,0.03-0.56,0.08c-0.19,0.05-0.38,0.11-0.57,0.17s-0.38,0.09-0.57,0.09 c-0.24,0-0.43-0.06-0.56-0.19c-0.13-0.13-0.2-0.3-0.2-0.5c0-0.28,0.13-0.54,0.38-0.77c0.25-0.23,0.59-0.41,1-0.54 s0.87-0.2,1.35-0.2c0.62,0,1.16,0.12,1.61,0.36c0.46,0.24,0.78,0.6,0.98,1.09c0.15,0.37,0.26,0.78,0.32,1.25 C64.97,10.61,65,11.1,65,11.62c0,0.52-0.04,0.93-0.1,1.22c-0.07,0.29-0.18,0.49-0.34,0.6S64.2,13.61,63.95,13.61z M61.93,12.28 c0.15,0,0.31-0.02,0.47-0.07c0.16-0.05,0.29-0.12,0.4-0.21c0.11-0.09,0.17-0.2,0.17-0.34c0-0.12-0.04-0.22-0.13-0.31 c-0.09-0.08-0.2-0.14-0.35-0.17s-0.3-0.05-0.47-0.05c-0.29,0-0.52,0.06-0.69,0.17c-0.17,0.11-0.25,0.25-0.25,0.43 c0,0.17,0.08,0.3,0.23,0.41C61.46,12.23,61.67,12.28,61.93,12.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.61,9.41c0-0.72,0.09-1.23,0.26-1.55c0.18-0.32,0.42-0.47,0.73-0.47c0.22,0,0.39,0.07,0.52,0.21 c0.13,0.14,0.22,0.31,0.28,0.51c0.06,0.2,0.08,0.41,0.08,0.62l-0.05-0.02c0.11-0.35,0.29-0.65,0.51-0.9 c0.23-0.25,0.51-0.38,0.83-0.38c0.43,0,0.74,0.16,0.94,0.49c0.2,0.33,0.3,0.73,0.3,1.22c0,0.65-0.1,1.1-0.29,1.36 c-0.19,0.26-0.45,0.39-0.77,0.39c-0.25,0-0.43-0.07-0.54-0.22s-0.16-0.37-0.13-0.68c0.01-0.26,0-0.45-0.04-0.54 c-0.04-0.1-0.1-0.15-0.19-0.15c-0.11,0-0.2,0.06-0.26,0.19c-0.06,0.13-0.09,0.3-0.09,0.51c0,0.13,0.02,0.29,0.05,0.49 c0.03,0.2,0.07,0.41,0.11,0.64c0.04,0.23,0.08,0.46,0.11,0.69c0.03,0.23,0.05,0.44,0.05,0.63c0,0.39-0.09,0.66-0.27,0.83 c-0.18,0.16-0.43,0.25-0.75,0.25c-0.31,0-0.57-0.08-0.76-0.24c-0.19-0.16-0.33-0.43-0.4-0.79c-0.04-0.25-0.08-0.56-0.12-0.92 c-0.04-0.36-0.08-0.74-0.1-1.12C65.62,10.06,65.61,9.72,65.61,9.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.15,7.68h-0.13C71.99,7.4,72,7.13,72.05,6.87c0.05-0.25,0.15-0.46,0.31-0.62c0.16-0.16,0.39-0.24,0.68-0.24 s0.51,0.07,0.64,0.21c0.14,0.14,0.2,0.33,0.2,0.59c0,0.36-0.08,0.66-0.24,0.91l-0.1-0.02c0.27-0.12,0.56-0.18,0.88-0.18 c0.33,0,0.6,0.07,0.8,0.22c0.2,0.15,0.3,0.39,0.3,0.74c0,0.32-0.11,0.57-0.34,0.74c-0.23,0.17-0.52,0.26-0.86,0.26 c-0.14,0-0.29-0.01-0.44-0.02s-0.31-0.04-0.46-0.08l0.08-0.14c0.08,0.21,0.16,0.44,0.23,0.7c0.08,0.26,0.14,0.53,0.2,0.81 s0.1,0.55,0.14,0.82c0.04,0.27,0.05,0.51,0.05,0.71c0,0.41-0.1,0.74-0.29,0.98c-0.19,0.24-0.48,0.36-0.87,0.36 c-0.25,0-0.46-0.05-0.62-0.15s-0.29-0.23-0.38-0.4c-0.09-0.17-0.16-0.36-0.19-0.58c-0.04-0.22-0.05-0.45-0.05-0.68 c0-0.24,0.02-0.51,0.05-0.8s0.08-0.6,0.15-0.92c0.07-0.32,0.15-0.62,0.23-0.92l0.13,0.22c-0.25,0.17-0.56,0.25-0.93,0.25 c-0.35,0-0.62-0.08-0.81-0.24c-0.2-0.16-0.29-0.41-0.29-0.74c0-0.35,0.11-0.62,0.32-0.81c0.21-0.19,0.5-0.29,0.86-0.29 c0.15,0,0.28,0.01,0.41,0.03C71.95,7.62,72.06,7.65,72.15,7.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.15,17.16c0.86,0,1.49,0.2,1.9,0.59c0.41,0.39,0.61,0.91,0.61,1.55c0,0.44-0.1,0.82-0.31,1.14s-0.49,0.57-0.85,0.75 c-0.36,0.18-0.77,0.27-1.22,0.27c-0.17,0-0.36-0.02-0.55-0.05s-0.39-0.09-0.6-0.17L44.2,21c0.05,0.15,0.1,0.33,0.13,0.55 c0.04,0.22,0.07,0.44,0.09,0.67c0.02,0.23,0.03,0.44,0.03,0.63c0,0.43-0.1,0.76-0.3,0.99c-0.2,0.23-0.5,0.34-0.9,0.34 c-0.31,0-0.55-0.08-0.72-0.23c-0.17-0.15-0.29-0.4-0.36-0.75c-0.07-0.34-0.1-0.81-0.1-1.38c0-0.85,0.05-1.57,0.15-2.17 c0.1-0.6,0.25-1.08,0.45-1.43c0.19-0.33,0.5-0.59,0.92-0.79C44.01,17.25,44.53,17.16,45.15,17.16z M44.89,20.13 c0.35,0,0.63-0.09,0.86-0.26c0.23-0.17,0.34-0.42,0.34-0.73c0-0.2-0.07-0.37-0.2-0.5c-0.13-0.13-0.35-0.2-0.66-0.2 c-0.23,0-0.44,0.05-0.62,0.15c-0.18,0.1-0.32,0.22-0.41,0.38c-0.1,0.16-0.15,0.33-0.15,0.53c0,0.19,0.07,0.35,0.21,0.46 C44.4,20.07,44.61,20.13,44.89,20.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.87,24.15c-0.58,0-1.08-0.12-1.52-0.34c-0.43-0.23-0.77-0.56-1-0.98c-0.24-0.43-0.35-0.93-0.35-1.52 c0-0.61,0.12-1.15,0.36-1.61c0.24-0.46,0.58-0.82,1.02-1.08c0.44-0.26,0.95-0.39,1.53-0.39c0.63,0,1.17,0.12,1.62,0.37 c0.46,0.25,0.81,0.6,1.06,1.04c0.25,0.45,0.38,0.97,0.38,1.56c0,0.61-0.13,1.13-0.38,1.57c-0.26,0.44-0.62,0.78-1.08,1.02 C52.04,24.03,51.49,24.15,50.87,24.15z M51.01,22.33c0.3,0,0.54-0.11,0.72-0.34c0.18-0.23,0.27-0.53,0.27-0.9 c0-0.37-0.09-0.67-0.27-0.9c-0.18-0.23-0.42-0.34-0.72-0.34c-0.31,0-0.55,0.11-0.73,0.33s-0.27,0.52-0.27,0.91 c0,0.38,0.09,0.68,0.27,0.9C50.46,22.22,50.7,22.33,51.01,22.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.16,24.23c-0.95,0-1.65-0.23-2.1-0.7s-0.67-1.11-0.67-1.94c0-0.64,0.13-1.21,0.4-1.7c0.27-0.49,0.65-0.88,1.15-1.16 c0.5-0.28,1.11-0.42,1.81-0.42c0.64,0,1.13,0.12,1.47,0.35c0.34,0.23,0.51,0.55,0.51,0.95c0,0.28-0.09,0.5-0.28,0.66 c-0.19,0.16-0.46,0.24-0.81,0.24c-0.15,0-0.29-0.01-0.42-0.03c-0.14-0.02-0.27-0.04-0.4-0.05s-0.26-0.02-0.39-0.02 c-0.32,0-0.56,0.07-0.73,0.22c-0.17,0.15-0.25,0.37-0.25,0.66c0,0.26,0.08,0.46,0.25,0.59c0.17,0.13,0.39,0.19,0.68,0.19 c0.13,0,0.26-0.01,0.4-0.04s0.28-0.06,0.43-0.08c0.15-0.03,0.29-0.04,0.43-0.04c0.27,0,0.49,0.07,0.66,0.22 c0.18,0.15,0.26,0.36,0.26,0.64s-0.09,0.54-0.26,0.76c-0.18,0.22-0.44,0.4-0.8,0.52C58.14,24.17,57.7,24.23,57.16,24.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.05,24.22c-0.21,0-0.37-0.04-0.5-0.14c-0.13-0.09-0.22-0.23-0.27-0.41c-0.06-0.21-0.11-0.53-0.15-0.98 c-0.04-0.45-0.06-0.93-0.06-1.45c0-0.68,0.02-1.33,0.07-1.96c0.05-0.63,0.12-1.14,0.2-1.54c0.09-0.44,0.22-0.76,0.41-0.96 s0.43-0.3,0.71-0.3c0.28,0,0.5,0.11,0.65,0.32c0.15,0.21,0.23,0.58,0.23,1.1c0,0.3-0.01,0.64-0.04,1 c-0.03,0.36-0.07,0.75-0.13,1.15h0.04c0.37-0.54,0.72-0.95,1.04-1.25c0.32-0.3,0.62-0.51,0.89-0.63 c0.27-0.12,0.52-0.18,0.73-0.18c0.31,0,0.55,0.09,0.7,0.28c0.15,0.18,0.23,0.41,0.23,0.68c0,0.39-0.22,0.75-0.66,1.08 s-1.13,0.66-2.07,0.98l0.07-0.16c0.57,0.25,1.04,0.5,1.42,0.76c0.38,0.26,0.67,0.52,0.86,0.78c0.19,0.26,0.29,0.52,0.29,0.79 c0,0.28-0.09,0.51-0.26,0.68c-0.18,0.17-0.42,0.25-0.73,0.25c-0.31,0-0.62-0.08-0.91-0.23c-0.3-0.15-0.58-0.4-0.84-0.75 s-0.5-0.81-0.72-1.38H62.2c-0.01,0.31-0.03,0.62-0.07,0.93s-0.09,0.56-0.14,0.77c-0.07,0.23-0.17,0.42-0.32,0.56 S61.31,24.22,61.05,24.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.36,24.2c-0.8,0-1.43-0.11-1.91-0.32c-0.47-0.21-0.82-0.52-1.03-0.92c-0.21-0.4-0.32-0.88-0.32-1.43 c0-0.7,0.15-1.3,0.44-1.8c0.3-0.49,0.7-0.87,1.22-1.14c0.52-0.26,1.1-0.4,1.75-0.4c0.78,0,1.35,0.16,1.71,0.46 c0.36,0.31,0.54,0.72,0.54,1.22c0,0.4-0.11,0.75-0.33,1.04s-0.53,0.51-0.93,0.67c-0.4,0.16-0.85,0.24-1.37,0.24 c-0.25,0-0.49-0.02-0.72-0.06s-0.45-0.1-0.64-0.17l0.24-0.51c-0.02,0.15-0.03,0.31-0.03,0.46c0,0.32,0.12,0.55,0.35,0.69 s0.56,0.2,0.97,0.2c0.37,0,0.68-0.04,0.94-0.11s0.47-0.15,0.66-0.22C71.1,22.04,71.28,22,71.44,22c0.11,0,0.23,0.03,0.34,0.08 c0.12,0.06,0.21,0.14,0.29,0.26s0.12,0.27,0.12,0.46c0,0.26-0.11,0.49-0.33,0.71c-0.22,0.21-0.53,0.38-0.95,0.51 C70.49,24.14,69.98,24.2,69.36,24.2z M68.79,20.88c0.36,0,0.66-0.08,0.91-0.25c0.25-0.16,0.37-0.36,0.37-0.6 c0-0.17-0.06-0.3-0.18-0.41c-0.12-0.1-0.29-0.15-0.52-0.15c-0.23,0-0.45,0.04-0.65,0.13c-0.2,0.09-0.36,0.2-0.48,0.33 s-0.18,0.29-0.18,0.46c0,0.16,0.06,0.27,0.19,0.36S68.56,20.88,68.79,20.88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3,18.29h-0.13c-0.03-0.28-0.02-0.55,0.03-0.81c0.05-0.26,0.15-0.46,0.31-0.62c0.16-0.16,0.39-0.24,0.68-0.24 s0.51,0.07,0.64,0.21c0.14,0.14,0.2,0.33,0.2,0.59c0,0.36-0.08,0.66-0.24,0.91l-0.1-0.02c0.27-0.12,0.56-0.18,0.88-0.18 c0.33,0,0.6,0.07,0.8,0.22c0.2,0.15,0.3,0.39,0.3,0.74c0,0.32-0.11,0.57-0.34,0.74s-0.52,0.26-0.86,0.26 c-0.14,0-0.29-0.01-0.44-0.02c-0.16-0.02-0.31-0.04-0.46-0.08l0.08-0.13c0.08,0.21,0.16,0.44,0.23,0.7 c0.08,0.26,0.14,0.53,0.2,0.81c0.06,0.28,0.1,0.55,0.14,0.82c0.04,0.27,0.05,0.5,0.05,0.71c0,0.41-0.1,0.74-0.29,0.98 c-0.19,0.24-0.48,0.36-0.87,0.36c-0.25,0-0.46-0.05-0.62-0.15c-0.16-0.1-0.29-0.23-0.38-0.4s-0.16-0.36-0.19-0.58 c-0.04-0.22-0.05-0.45-0.05-0.68c0-0.24,0.02-0.51,0.05-0.8s0.08-0.6,0.15-0.92c0.07-0.32,0.15-0.62,0.23-0.92l0.13,0.22 c-0.25,0.17-0.56,0.25-0.93,0.25c-0.35,0-0.62-0.08-0.81-0.24c-0.2-0.16-0.29-0.41-0.29-0.74c0-0.35,0.11-0.62,0.32-0.81 s0.5-0.29,0.86-0.29c0.15,0,0.28,0.01,0.41,0.03C74.09,18.23,74.2,18.26,74.3,18.29z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 33.96,
    cy: 25.99,
    rx: 3.08,
    ry: 2.85
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 21.64,
    cy: 25.99,
    rx: 3.08,
    ry: 2.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.12,7.01v4.57c0,0.1-0.02,0.2-0.05,0.29l-2.9,8.8c-0.08,0.24-0.25,0.44-0.49,0.57l-8.36,4.46 c-0.33,0.18-0.74,0.18-1.07,0l-8.34-4.46c-0.23-0.12-0.41-0.33-0.49-0.57l-2.91-8.8c-0.03-0.09-0.05-0.19-0.05-0.29V7.01 c0-0.55,0.48-0.99,1.07-0.99h22.52C39.65,6.02,40.12,6.46,40.12,7.01z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "38.25,12.33 35.81,20.3 27.8,24.38 20.06,19.82 17.35,12.33  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "15.52,11.86 27.8,15 40.08,11.86  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M30.86,6.28c0,0.52-0.15,1-0.41,1.42c-0.05,0.08-0.1,0.16-0.17,0.24c-0.16,0.13-0.3,0.28-0.42,0.43 c-0.27,0.33-0.45,0.72-0.53,1.14c-0.01,0.04-0.02,0.09-0.02,0.14c-0.02,0.13-0.03,0.26-0.03,0.39c0,0.1,0.01,0.2,0.02,0.29 c0.02,0.18,0.06,0.35,0.11,0.52v0.18c-0.27,0.56-0.91,0.95-1.65,0.95c-0.73,0-1.37-0.38-1.64-0.93v-0.18 c0.01,0,0.01-0.01,0.01-0.02c0.08-0.26,0.13-0.53,0.13-0.81c0-0.14-0.01-0.27-0.04-0.4c0-0.03-0.01-0.07-0.02-0.11 c-0.08-0.46-0.29-0.89-0.59-1.24c-0.01,0-0.01-0.01-0.02-0.02c-0.06-0.08-0.14-0.16-0.21-0.23c-0.01,0-0.02-0.01-0.02-0.02 c-0.09-0.1-0.17-0.21-0.23-0.32C24.85,7.29,24.7,6.8,24.7,6.28c0-1.58,1.38-2.86,3.08-2.86C29.49,3.43,30.86,4.71,30.86,6.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M26.6,6.7c0.06,0.11,0.24,0.36,0.58,0.51c0.55,0.24,1.08,0.02,1.18-0.02c0.36-0.16,0.55-0.42,0.62-0.53"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 28.22,
    y1: 5.06,
    x2: 28.22,
    y2: 6.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M29.41,10.86v0.18c-0.27,0.56-0.91,0.95-1.65,0.95c-0.73,0-1.37-0.38-1.64-0.93v-0.2H29.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M27.9,2.84h-0.24c-0.02,0-0.04-0.02-0.04-0.04V1.2c0-0.02,0.02-0.04,0.04-0.04h0.24 c0.02,0,0.04,0.02,0.04,0.04v1.6C27.94,2.82,27.92,2.84,27.9,2.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M32.52,3.56L32.52,3.56c0.04,0.07,0.02,0.16-0.06,0.2l-1.3,0.69c-0.08,0.04-0.17,0.02-0.22-0.05v0 c-0.04-0.07-0.02-0.16,0.06-0.2l1.3-0.69C32.38,3.47,32.48,3.49,32.52,3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M25.83,3.34L25.83,3.34c-0.08,0.04-0.17,0.02-0.22-0.05l-0.75-1.2c-0.04-0.07-0.02-0.16,0.06-0.2v0 c0.08-0.04,0.17-0.02,0.22,0.05l0.75,1.2C25.93,3.21,25.9,3.3,25.83,3.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M29.7,3.32L29.7,3.32c-0.08-0.04-0.1-0.13-0.06-0.2l0.75-1.2c0.04-0.07,0.14-0.09,0.22-0.05l0,0 c0.08,0.04,0.1,0.13,0.06,0.2l-0.75,1.2C29.87,3.33,29.77,3.36,29.7,3.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M23.08,3.56L23.08,3.56c0.04-0.07,0.14-0.09,0.22-0.05l1.3,0.69c0.08,0.04,0.1,0.13,0.06,0.2v0 c-0.04,0.07-0.14,0.09-0.22,0.05l-1.3-0.69C23.06,3.72,23.03,3.63,23.08,3.56z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 27.28,
    y1: 5.06,
    x2: 27.28,
    y2: 6.35
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2_00000078759062304011077180000009979483890779018390_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M12.01,5.72c-0.45-2.53,1.17,1.49,3.46-0.37v1.65"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartPocketV2LogoWeb200X40Px);
export default __webpack_public_path__ + "static/media/Smart_Pocket_V2_Logo_Web_200x40px.a301fe075e0c2defd3c660f1d074a2c2.svg";
export { ForwardRef as ReactComponent };